import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";
import { registerServiceWorker } from "@/lib/sw-register";
import { isNative } from "@/lib/appConfig";
import { capturarTokenDeUrl } from "@/lib/urlTokens";
import { parkOAuthReturn, bounceAppOAuthReturn } from "@/lib/oauthReturn";
import { capturarOrigen } from "@/lib/acquisition";

// Una autorizacion empezada en la app vuelve a la web: se devuelve a la app sin
// montar nada (ni analitica) en el navegador del sistema.
const bounced = bounceAppOAuthReturn(isNative());

if (!bounced) {
  // Antes de montar la app: initAnalytics() inyecta gtag desde un efecto de App,
  // y gtag lee document.location al enviar el primer page_view. Si el token sigue
  // en la barra de direcciones a esas alturas, se va con el.
  capturarTokenDeUrl();
  parkOAuthReturn();
  capturarOrigen();

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  );
}

// Skip the service worker inside the native WebView — it would cache a stale app
// shell across native app updates. Web (PWA) keeps it.
if (!isNative() && !bounced) {
  registerServiceWorker();
}
